<template>
  <div class="position-relative" v-click-outside="close">
    <input type="text"
           class="form-control form-control-sm"
           readonly
           :placeholder="placeholder"
           :value="displayValue"
           @click="isOpen = !isOpen">
    <div v-if="isOpen" class="range-picker-popup card p-2 shadow-sm">
      <div class="d-flex flex-wrap" style="gap: 8px;">
        <div>
          <label class="filter-label d-block mb-1">Սկիզբ</label>
          <date-pick :value="from"
              @input="$emit('update:from', $event)"
              :format="'YYYY-MM-DD'"
              :displayFormat="'DD/MM/YYYY'"
              :inputAttributes="{class: 'form-control form-control-sm', readonly: true}"
              :weekdays="weekdays"
              :months="months">
          </date-pick>
        </div>
        <div>
          <label class="filter-label d-block mb-1">Ավարտ</label>
          <date-pick :value="to"
              @input="$emit('update:to', $event)"
              :format="'YYYY-MM-DD'"
              :displayFormat="'DD/MM/YYYY'"
              :inputAttributes="{class: 'form-control form-control-sm', readonly: true}"
              :weekdays="weekdays"
              :months="months">
          </date-pick>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'AppDateRangePicker',
  components: { DatePick },
  directives: { ClickOutside },
  props: {
    from: { type: String, default: '' },
    to: { type: String, default: '' },
    placeholder: { type: String, default: 'Ընտրել ժամկետը' },
  },
  data() {
    return {
      isOpen: false,
      weekdays: ['Երկ', 'Երք', 'Չոր', 'Հին', 'Ուր', 'Շբթ', 'Կիր'],
      months: ['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր'],
    }
  },
  computed: {
    displayValue() {
      if (!this.from && !this.to) return ''
      return `${this.formatDate(this.from)} - ${this.formatDate(this.to)}`
    },
  },
  methods: {
    formatDate(d) {
      if (!d) return '...'
      const [y, m, day] = d.split('-')
      return `${day}/${m}/${y}`
    },
    close() {
      this.isOpen = false
    },
  },
}
</script>

<style scoped>
.position-relative > input.form-control-sm {
  height: calc(1.5em + .5rem + 2px);
  margin: 0;
  padding: .25rem .5rem;
  font-size: .875rem;
  box-sizing: border-box;
  line-height: 1.5;
}
.range-picker-popup {
  position: absolute;
  z-index: 1010;
  top: 100%;
  left: 0;
  background: #fff;
  white-space: nowrap;
}
</style>
